import styled from "@emotion/styled"
import HeroTitle from "../Hero/HeroTitle"

const HeroCaseTitle = styled(HeroTitle)`
  ${({ theme }) => theme.breakpoints.down("md")} {
    max-width: 370px;
    margin-bottom: 34px;
    line-height: 48px;
  }
  ${({ theme }) => theme.breakpoints.between("md", "xl")} {
    max-width: 510px;
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    max-width: 660px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    max-width: 820px;
  }
`

export default HeroCaseTitle
